import React, { useState } from "react";
import { Modal, ModalHeader, ListGroup, Card } from "reactstrap";
import { todoVisiblityFilter } from "../../redux/todos/Action";
import FilterLink from "./FliterLink";
import AddTodo from "./AddTodo";

const TodosFilter = (props) => {
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };
  return (
    <div>
      <div className="p-3">
        <span
          onClick={toggle.bind(null)}
          style={{
            backgroundColor: '#1EF1C6', 
            borderRadius: '4px',
            cursor: 'pointer'
          }}
          className="btn btn-success d-block text-darky"
        >
          Add task
        </span>
      </div>

      <div className="filter-listing"
      >
        <ListGroup flush>
          <FilterLink filter={todoVisiblityFilter.SHOW_ALL_TODO}>
            <i className="ti-clipboard mr-2"></i> All
          </FilterLink>
        </ListGroup>
        <hr className="" />
        <h6 className="mb-0 mt-2 p-3">Filters</h6>
        <ListGroup flush>
          <FilterLink filter={todoVisiblityFilter.STARRED_TODO}>
            <i className="far fa-star mr-2"></i> Starred
          </FilterLink>
          <FilterLink filter={todoVisiblityFilter.COMPLETED_TODO}>
            <i className="far fa-check-circle mr-2"></i> Completed Tasks
          </FilterLink>
          <FilterLink filter={todoVisiblityFilter.DELETED_TODO}>
            <i className="icon-trash mr-2"></i> Deleted Tasks
          </FilterLink>
        </ListGroup>
      </div>
      <Modal
        isOpen={modal}
        toggle={toggle.bind(null)}
        className={props.className}
        size="md"
        style={{ marginTop: '45px', marginLeft: '650px' }}
      >
        <ModalHeader toggle={toggle.bind(null)}>New Task</ModalHeader>
        <AddTodo onButtonClick={toggle.bind(null)} />
      </Modal>
    </div>
  );
};

export default TodosFilter;